import React, { useState } from 'react';

const VisitorMonitor = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = (e) => {
    e.preventDefault();
    if (username === 'admin' && password === 'Formanek5029') {
      setIsLoggedIn(true);
    } else {
      alert('Nesprávné přihlašovací údaje!');
    }
  };

  if (!isLoggedIn) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white">
        <form onSubmit={handleLogin} className="bg-gray-800 p-6 rounded shadow-md">
          <h2 className="text-lg font-bold mb-4">Přihlášení</h2>
          <div className="mb-4">
            <label className="block mb-2">Uživatelské jméno</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2">Heslo</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
            />
          </div>
          <button type="submit" className="bg-blue-500 px-4 py-2 rounded">Přihlásit se</button>
        </form>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6">
      <h1 className="text-2xl font-bold mb-4">Monitorování návštěvníků</h1>
      <p>Tato stránka bude obsahovat data o návštěvnících.</p>
    </div>
  );
};

export default VisitorMonitor;
